import { render, staticRenderFns } from "./ResumoAcordoTribanco.vue?vue&type=template&id=1340a43a&scoped=true"
import script from "./ResumoAcordoTribanco.vue?vue&type=script&lang=js"
export * from "./ResumoAcordoTribanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340a43a",
  null
  
)

export default component.exports